import { call, put } from 'redux-saga/effects';
import { handleServerError } from 'store/alerts/actions';
import { fetchApi } from 'store/karmaEarnGame/api';
import { receiveItem } from 'store/karmaEarnGame/actions';
import { PATHS } from 'consts/paths';

function* fetchWorker({ payload: { id } }) {
  try {
    const { data } = yield call(fetchApi, { id });

    if (!data?.id) {
      window.location.href = PATHS.KARMA_EARN_LIST;

      return;
    }

    yield put(receiveItem(data));
  } catch (error) {
    yield put(handleServerError(error));
    window.location.href = PATHS.KARMA_EARN_LIST;
  }
}

export default fetchWorker;
